// One sentence, two weights: the claim in white, the explanation in gray, as a
// single heading. Every homepage section uses it so the page reads in one voice.
export function SectionHeading({
  lead,
  rest = '',
  stacked = false,
  className = '',
}: {
  lead: string
  rest?: string
  /** Force the gray line onto its own row when the lead is too short to fill the first one. */
  stacked?: boolean
  className?: string
}) {
  return (
    <h2
      className={`max-w-[860px] text-[34px] font-semibold leading-[1.08] tracking-[-0.03em] md:text-[52px] ${stacked ? 'text-balance' : ''} ${className}`}
    >
      <span className="text-white">{lead}</span>
      {rest && <span className={`text-white/40 ${stacked ? 'block' : ''}`}> {rest}</span>}
    </h2>
  )
}

// The editor's canvas gray, so the page and the product share one surface.
export const CANVAS_BG = 'bg-[#141414]'
// Sections alternate between canvas gray and one step darker, each opened by a hairline,
// so the page reads as distinct bands instead of one endless black.
const sectionBase = 'relative border-t border-white/[0.07] px-6 py-28 text-white md:px-8 md:py-40 lg:px-12'
export const sectionShell = `${sectionBase} ${CANVAS_BG}`
export const sectionShellAlt = `${sectionBase} bg-[#0e0e0e]`
export const sectionInner = 'mx-auto max-w-[1200px]'
